// ENGLISH

export default {
    values: {
        timespan_start: "Start",
        timespan_end: "End"
    }
}
